var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//  @jsx h

/* eslint-disable jsx-a11y/aria-role */

import { h } from 'preact';
import PureComponent from '../lib/preact-pure-component';
var style = {
  'pullQuote': 'dhfc-1_0_0-beta_26-pullQuote',
  'pullQuote__content': 'dhfc-1_0_0-beta_26-pullQuote__content',
  'pullQuote__footer': 'dhfc-1_0_0-beta_26-pullQuote__footer'
};

var PullQuote = function (_PureComponent) {
  _inherits(PullQuote, _PureComponent);

  function PullQuote() {
    _classCallCheck(this, PullQuote);

    return _possibleConstructorReturn(this, (PullQuote.__proto__ || Object.getPrototypeOf(PullQuote)).apply(this, arguments));
  }

  _createClass(PullQuote, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cite = _props.cite,
          html = _props.html;

      var className = '' + style.pullQuote + (this.props.className ? ' ' + this.props.className : '');

      return h(
        'blockquote',
        { className: className },
        h(
          'div',
          { className: style.pullQuote__content },
          h('p', { dangerouslySetInnerHTML: { __html: html } })
        ),
        cite && h(
          'footer',
          { className: style.pullQuote__footer },
          h(
            'cite',
            { role: 'text' },
            h(
              'svg',
              { viewBox: '0 0 20 30', 'aria-hidden': 'true' },
              h('path', { d: 'M 5.5,5.5 L5.5,24.5 L14.5,24.5' }),
              h('circle', { cx: '5.5', cy: '5.5', r: '3.5' })
            ),
            h('span', {
              dangerouslySetInnerHTML: {
                __html: '<span class="nrk-sr">\u2013 </span>' + (cite || '')
              }
            })
          )
        )
      );
    }
  }]);

  return PullQuote;
}(PureComponent);

export default PullQuote;


// WEBPACK FOOTER //
// ./node_modules/@nrk/dh-feature-components/dist/module/PullQuote/index.js